import styled from 'styled-components'

import ContentContainer from '@hixme-ui/content-container'

const Container = styled(ContentContainer)`
  font-family: 'SF Pro Text';
`

export default Container
